import { makeStyles } from "@material-ui/core";
import { fontFamily } from "../../../../app/theme";

export const useAftercareStyles = makeStyles((theme) => ({
  root: {
    fontFamily: fontFamily.Axiforma
  },
  different: {
    color: "#f7815c"
  },
  title: {
    color: "#160337",
    fontSize: 28,
    fontWeight: 500,
    [theme.breakpoints.down("md")]: {
      fontSize: 20,
      padding: `0px 20px`
    }
  },
  container: {
    paddingInline: 375,
    [theme.breakpoints.down("lg")]: {
      paddingInline: 150
    },
    [theme.breakpoints.down("md")]: {
      paddingInline: 25
    }
  }
}));
